define('SC.ThreadsThemeExtension.ApplicationSkeleton.Layout', [
  'SC.ThreadsThemeExtension.Common.UtilitiesHelper'
], function QSApplicationSkeletonLayout(
  Utils
) {
  'use strict';
  return {

    loadModule: function loadModule() {

        var HeaderHeight;

        jQuery(window).scroll(function () {

        if (!HeaderHeight){
          HeaderHeight = jQuery('#site-header').outerHeight(true);
        }

        var y = jQuery(this).scrollTop();

        //Mobile fixed header is not optional, so we'll run it from outside the fixedHeader conditional.
        if ($(window).width() < 992) {//checking the screen-size
          if (jQuery('header').hasClass('checkout-layout-header')) {
            //do nothing
          } else {
            if (y >= 100 && y < 200) {//the header is a lot smaller, so we'll set a 100points scroll instead of 300
              jQuery('body').addClass('fixed-header-mobile');
              jQuery('#main-container').css('padding-top', '0px');//this resolve a weird responsive behavior.
            }
            if (y < 99) {
              jQuery('body').removeClass('fixed-header-mobile');
            }
          }
        }
      });
    }
  }
});
